import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  Input,
  numberAttribute,
  OnInit,
  output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule } from '@angular/forms';

import { SelectModule } from '@hglobal/common';
import { FormBuilder, FormGroup } from '@ngneat/reactive-forms';
import { GroupResolverFormBuilder } from '@ngneat/reactive-forms/lib/form-builder';

@Component({
  selector: 'pp-select-small',
  imports: [SelectModule, ReactiveFormsModule],
  templateUrl: './select-small.component.html',
  styleUrl: './select-small.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectSmallComponent implements OnInit {
  readonly #fb = inject(FormBuilder);
  readonly #destroyRef = inject(DestroyRef);

  readonly iconDisabled = input(false, { transform: booleanAttribute });
  readonly changeEvent = output<any>();

  form: FormGroup<GroupResolverFormBuilder<{ data: any }>>;
  items: any[];

  @Input({ transform: numberAttribute }) set selected(value: number) {
    if (!this.form) {
      return;
    }

    this.form.controls.data.setValue(value);
  }

  @Input() set itemList(value: any[]) {
    this.items = this.iconDisabled() ? this.#excludeIcon(value) : value;
  }

  ngOnInit(): void {
    this.form = this.#fb.group({
      data: null,
    });

    this.form.controls.data.valueChanges.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((value: any) => {
      this.changeEvent.emit(value);
    });
  }

  #excludeIcon(items: any[]): any[] {
    return items.map(({ _icon, _image, ...rest }) => rest);
  }
}
